import {FormikErrors} from 'formik';
import {set} from 'lodash-es';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';

export const adHocFeeValidator = (
  values: recommendFieldsType,
  errors: FormikErrors<recommendFieldsType>
): FormikErrors<recommendFieldsType> => {
  if (values.adHocFee?.feeType === 'GBP') {
    if (values.adHocFee.monetaryFee && values.adHocFee.planValue) {
      if (Number(values.adHocFee.monetaryFee) > Number(values.adHocFee.planValue)) {
        set(errors, `adHocFee.monetaryFee`, 'Must be less than the plan value');
      }
    }
  } else {
    if (values.adHocFee?.percentFee && values.adHocFee.planValue) {
      if (Number(values.adHocFee?.percentFee) > 100) {
        set(errors, `adHocFee.percentFee`, 'Must be lower than or equal to 100%');
      }
    }
    if (values.adHocFee?.planValue && Number(values.adHocFee?.planValue) === 0) {
      set(errors, `adHocFee.percentFee`, 'Cannot charge a fee on a plan with £0 value');
    }
  }
  return errors;
};
